import React from 'react';
import { motion } from 'framer-motion';
type CTAButtonProps = {
  text: string;
  isPrimary?: boolean;
  className?: string;
};
export function CTAButton({
  text,
  isPrimary = true,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.button onClick={handleClick} className={`
        relative w-full md:w-auto px-8 py-5 
        bg-[#FF6B00] hover:bg-[#E55A00] 
        text-white font-bold text-lg md:text-xl 
        rounded-xl shadow-lg 
        transition-colors duration-200
        cursor-pointer
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0 0 0 0 rgba(255, 107, 0, 0.4)', '0 0 0 15px rgba(255, 107, 0, 0)', '0 0 0 0 rgba(255, 107, 0, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-33">
      {text}
    </motion.button>;
}